export default "__VITE_ASSET__4bef4bd1__"